export const CONTACT_SOCIALS = [
  { label: 'Linkedin', value: 'linkedin' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Stack overflow', value: 'stackoverflow' },
  { label: 'Website', value: 'website' },
  { label: 'Github', value: 'github' },
];

export const DEGREE_LIST = [
  {
    id: 1,
    name: 'Primary education',
  },
  {
    id: 2,
    name: 'Lower secondary education',
  },
  {
    id: 3,
    name: 'Upper secondary education',
  },
  {
    id: 4,
    name: 'Post-secondary non-tertiary education',
  },
  {
    id: 5,
    name: 'Short-cycle tertiary education',
  },
  {
    id: 6,
    name: "Bachelor's or equivalent",
  },
  {
    id: 7,
    name: "Master's or equivalent",
  },
  {
    id: 8,
    name: 'Doctor or equivalent',
  },
  {
    id: 9,
    name: "Bachelor's Degree",
  },
  {
    id: 10,
    name: "Engineer's Degree",
  },
  {
    id: 11,
    name: 'High School',
  },
  {
    id: 12,
    name: 'Doctor of Philosophy (Ph.D.)',
  },
  {
    id: 13,
    name: 'Juris Doctor (J.D.)',
  },
  {
    id: 14,
    name: "Master's Degree",
  },
  {
    id: 15,
    name: 'Other',
  },
];

// The create-contact API returns this verbatim when any submitted experience
// fails a model validation. It names no entry, so the drawer works out which
// rows to mark itself (see getInvalidExperienceFieldErrors).
export const INVALID_EXPERIENCE_API_ERROR =
  'Contact experiences is invalid, User contacts contact contact experiences is invalid';

export const INVALID_EXPERIENCE_TOAST =
  'Invalid candidate experience. Review it and try again.';
export const INVALID_EXPERIENCE_FIELD_ERROR =
  'Invalid experience. Review it and try again.';
export const EXPERIENCE_END_BEFORE_START_ERROR =
  'Invalid experience. End date must be after start date.';
export const EXPERIENCE_TITLE_TOO_LONG_ERROR =
  'Title must be 255 characters or fewer.';

// Mirrors ContactExperience's `title` length validation on the backend.
export const EXPERIENCE_TITLE_MAX_LENGTH = 255;

// Education and experience rows are numbered 1, 10, 19, … — one step per row,
// whether or not the row draws a divider. Resume autofill writes its values
// under these same ids, so both sides must use this step.
export const HISTORY_ROW_ID_STEP = 9;
